import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from 'cprime-foundational-components';
import * as S from './TooltipWrapper.styles';

const TooltipWrapper = ({ children, tooltipText, isDisabled = false, ...rest }) => {
  if (isDisabled) {
    return children;
  }
  return (
    <S.StyledTooltip
      istitle={+!!tooltipText}
      title={
        tooltipText && (
          <Typography whiteSpace="pre-line" variant="label" component="span">
            {tooltipText}
          </Typography>
        )
      }
      placement="bottom"
      arrow={!!tooltipText}
      {...rest}
    >
      {children}
    </S.StyledTooltip>
  );
};

TooltipWrapper.propTypes = {
  tooltipText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  children: PropTypes.node,
  isDisabled: PropTypes.bool,
};

export default TooltipWrapper;
